<template>
  <div>
    <!-- 具体要求选择 -->
    <el-dialog :title="$t('message.specificRequirementsSelection')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1220px" center>
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
          <!-- 任务类型 -->
          <el-form-item :label="$t('message.taskType') + ':'" prop="type">
            <el-select v-model="ruleForm.type">
              <el-option v-for="item in options" :key="item.key" :label="item.name" :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 执行人 -->
          <el-form-item :label="$t('message.executor') + ':'" prop="execute_by">
            <el-select v-model="ruleForm.execute_by" clearable filterable>
              <el-option v-for="item in adminList" :key="item.key" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 消息推送人 -->
          <el-form-item :label="$t('message.messageRecipient') + ':'">
            <el-select v-model="ruleForm.msg_receive" multiple clearable filterable>
              <el-option v-for="(item, index) in adminList" :key="index" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 任务截止时间 -->
          <!-- <el-form-item :label="$t('message.taskDeadline') + ':'" prop="end_at">
            <el-date-picker v-model="ruleForm.end_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item> -->
          <!-- 具体抽查要求：-->
          <el-form-item :label="$t('message.specificSpotCheckRequirements') + ':'" prop="desc">
            <div class="specificSpotCheckRequirements">
              <!-- 从系统选择抽查内容-->
              <el-button type="primary" @click="specificSpotCheckRequirements">{{
                $t('message.selectSpotCheckContentFromSystem') }}</el-button>
              <!-- 手动添加 -->
              <el-button type="primary" @click="manuallyAdd">{{ $t('message.manuallyAdd') }}</el-button>
              <div class="table">
                <ol>
                  <li>NO</li>
                  <!-- 具体要求 -->
                  <li class="flex3">{{ $t('message.specificRequirements') }}</li>
                  <!-- 操作 -->
                  <li>{{ $t('message.operation') }}</li>
                </ol>
                <ul v-for="(item, index) in ruleForm.desc" :key="index">
                  <li>{{ index + 1 }}</li>
                  <!-- 具体要求 -->
                  <li class="flex3">{{ item }}</li>
                  <!-- 操作 -->
                  <li>
                    <el-button type="primary" @click="ruleForm.desc.splice(index, 1)">
                      {{ $t('message.delete') }}
                    </el-button>
                  </li>
                </ul>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--创建任务  -->
        <el-button type="primary" @click="createTask">
          {{ $t("message.createTask") }}</el-button>
      </span>
    </el-dialog>
    <!-- 从系统选择抽查内容 -->
    <specificRequirementsSelection ref="specificRequirementsSelection" :typeName="typeName" :taskType="ruleForm.type" />
    <!-- 手动添加要求 -->
    <manuallyAddRequirements ref="manuallyAddRequirements" />
  </div>
</template>
<script>
import specificRequirementsSelection from './specificRequirementsSelection'
import manuallyAddRequirements from './manuallyAddRequirements'
import { lastFewDays, transferDate } from '@/utlis/date'
export default {
  components: {
    specificRequirementsSelection,
    manuallyAddRequirements,
  },

  data() {
    return {
      executeTypeList: [], // 执行类型
      options: [], // 分类枚举
      adminList: [], // 管理员列表
      dialogVisible: false,
      typeList: ['1', '2'],// 分类列表
      typeName: '', // 分类名称
      rules: {
        type: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        // end_at: [{
        //   required: true,
        //   message: this.$t("message.TheRequired"),
        //   trigger: "blur",
        // },],
        execute_by: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "change",
        },],
        msg_receive: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        desc: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        spot_detail: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
      },
      ruleForm: {
        type: '',
        spot_sn: '',
        execute_by: '',
        // end_at: lastFewDays(new (Date), 3),
        msg_receive: [],
        desc: [],
        spot_detail: [],
        is_preset: 1
      },
    };
  },
  created() {

  },
  methods: {
    // 具体抽查要求 从系统选择抽查内容
    specificSpotCheckRequirements() {
      this.typeName = this.options.find(item => item.key == this.ruleForm.type).name
      this.$refs.specificRequirementsSelection.expectList()
    },
    //手动添加
    manuallyAdd() {
      this.$refs.manuallyAddRequirements.dialogVisible = true
      this.$refs.manuallyAddRequirements.content = ''
    },
    //加入任务
    addToTask(list) {
      list.forEach(item => {
        this.ruleForm.desc.push(item.desc)
      })
      this.ruleForm.desc = [...new Set(this.ruleForm.desc)];
      this.$refs.ruleForm.validate(valid => { })
      this.$forceUpdate()
    },
    // 创建任务
    createTask() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {

          // 获取新单号
          this.$api.spotCheckApi.getNewSpotSn({ type: this.ruleForm.type }).then(res => {
            this.ruleForm.spot_sn = res.data.spot_sn
            // 到货核查
            if (this.ruleForm.type == 1) {
              this.storeType1()
            }
            // 检品核查
            if (this.ruleForm.type == 2) {
              this.storeType2()
            }

          });
        }
      })
    },
    //到货核查-新建任务
    storeType1() {
      this.ruleForm.spot_detail = []
      this.ids.forEach(item => {
        this.ruleForm.spot_detail.push({
          order_detail_id: item,
        })
      })

      // 新建任务
      this.$api.spotCheckApi.storeType1(this.ruleForm).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        let spot_detail = this.setSpot_detail()
        this.$parent.successPresetTask(spot_detail)
      });
    },
    //检品核查-新建任务
    storeType2() {
      this.ruleForm.spot_detail = []
      this.ids.forEach(item => {
        this.ruleForm.spot_detail.push({
          order_detail_id: item,
        })
      })
      // 新建任务
      this.$api.spotCheckApi.storeType2(this.ruleForm).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        let spot_detail = this.setSpot_detail()
        this.$parent.successPresetTask(spot_detail)
      });
    },
    // 设置spot_detail
    setSpot_detail() {
      let spot_detail = {
        created_at: transferDate(new Date()),
        execute_by_name: '',
        desc: this.ruleForm.desc,
        type_name: '',
        spot_sn: this.ruleForm.spot_sn,
      }
      spot_detail.type_name = this.options.find(item => item.key == this.ruleForm.type).name
      spot_detail.execute_by_name = this.adminList.find(item => item.id == this.ruleForm.execute_by).realname
      return spot_detail
    },
  },
  watch: {
    dialogVisible() {
      if (!this.dialogVisible) return
      this.ruleForm = {
        type: '',
        spot_sn: '',
        execute_by: '',
        // end_at: lastFewDays(new (Date), 3),
        msg_receive: [],
        desc: [],
        spot_detail: [],
        is_preset: 1
      }
      // 同组织各工种账号列表
      this.$api.getAuthWorkGroupAdminDepart({ format_list: 1 }).then(res => {
        this.adminList = res.data
      })
      // 分类枚举
      this.options = []
      this.$api.spotCheckApi.spotTypeList().then(res => {
        this.typeList.forEach(item => {
          let resItem = res.data.find(resItem => resItem.key == item)
          if (resItem) {
            this.options.push(resItem)
          }
        })
      })
      // 执行人
      this.$api.spotCheckApi.executeTypeList().then(res => {
        this.executeTypeList = res.data
      })
    },
  },
}
</script>
<style lang='scss' scoped>
.content {
  position: relative;

  .storeType {
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 9;
  }

  /deep/.el-form-item {
    margin-bottom: 30px;
  }

  .table {
    margin-top: 20px;

    ol {
      height: 50px;
    }

    ul {
      background-color: #fff;
      padding: 20px 0;
    }

    .flex3 {
      flex: 3;
    }

    .flex2 {
      flex: 2;
    }

  }

  .specificSpotCheckRequirements {
    .table {
      width: 772px;
    }
  }

}
</style>